/**
 * Asserts that the FB SDK has not written token data to localStorage or sessionStorage.
 *
 * The FB SDK's localStorage:false init flag is undocumented and may stop working in a
 * future SDK version. Call this after every FB.login() to surface regressions immediately.
 */
export function assertFbSdkDidNotCacheTokens(appId: string): void {
  const fbLocalStorage = localStorage.getItem(`fblst_${appId}`);
  const fbSessionStorage = sessionStorage.getItem(`fbssls_${appId}`);
  if (fbLocalStorage !== null || fbSessionStorage !== null) {
    console.error(
      "SECURITY: FB SDK wrote token data to storage after login. " +
        "The undocumented localStorage:false flag may no longer be effective. " +
        "Review FB.init configuration in Connect.tsx and BroadcastConnect.tsx.",
      { fbLocalStorage, fbSessionStorage },
    );
  }
}
